var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGatesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 129,
    viewBox: "0 0 190 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_872_132239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7308 0.00375943L26.197 0.00375973L26.197 53.3371L44.0566 53.3371L44.0566 56.7975L22.7308 56.7975L22.7308 0.00375943Z",
    fill: "url(#paint0_linear_872_132239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.611 112.631C122.748 118.166 114.627 121.929 105.962 123.588C97.2978 125.246 88.3578 124.749 79.9316 122.14C71.5053 119.531 63.8521 114.891 57.6481 108.629C51.4441 102.368 46.8802 94.6771 44.3594 86.2369L40.7459 86.2369C43.2901 95.3527 48.0639 103.694 54.638 110.511C61.2122 117.329 69.3804 122.408 78.4083 125.292C87.4363 128.176 97.0408 128.775 106.358 127.035C115.675 125.294 124.413 121.269 131.786 115.322C141.032 107.84 147.724 97.6776 150.937 86.2369L147.323 86.2369C144.209 96.6114 138.036 105.809 129.611 112.631Z",
    fill: "url(#paint1_linear_872_132239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000971679 0.00339373L0.00096462 80.7517L48.6144 80.7517C50.7677 91.45 56.565 101.074 65.0211 107.988C73.4772 114.903 84.0704 118.681 95.0009 118.681C105.931 118.681 116.525 114.903 124.981 107.988C133.437 101.074 139.234 91.45 141.387 80.7517L190.001 80.7517L190.001 0.00341034L173.432 0.00340889L173.432 63.7871L16.5867 63.7871L16.5867 0.00339518L0.000971679 0.00339373ZM121.881 80.7517C119.959 86.3448 116.335 91.1988 111.515 94.6353C106.695 98.0717 100.92 99.919 94.9966 99.919C89.0736 99.919 83.2983 98.0717 78.4782 94.6353C73.6581 91.1988 70.0338 86.3448 68.1118 80.7517L121.881 80.7517Z",
    fill: "#FF004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0178 49.1412C101.906 43.7072 107.996 37.3357 113.111 30.2129C107.994 23.0946 101.903 16.7263 95.0178 11.2932C88.1364 16.7309 82.0469 23.0986 76.9244 30.2129C82.0444 37.3317 88.1342 43.7026 95.0178 49.1412Z",
    fill: "#FF004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.724 40.8277C165.729 45.2528 165.729 49.8463 164.724 54.2714C160.291 55.2749 155.69 55.2749 151.257 54.2714C150.252 49.8463 150.252 45.2528 151.257 40.8277C155.69 39.8242 160.291 39.8242 164.724 40.8277Z",
    fill: "url(#paint2_linear_872_132239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.609 27.9719C158.112 30.1844 158.112 32.4812 157.609 34.6937C155.393 35.1954 153.093 35.1954 150.876 34.6937C150.374 32.4812 150.374 30.1844 150.876 27.9719C153.093 27.4703 155.393 27.4703 157.609 27.9719Z",
    fill: "#550065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.975 41.3121C145.477 43.5246 145.477 45.8214 144.975 48.0339C142.759 48.5442 140.457 48.5442 138.242 48.0339C137.739 45.8214 137.739 43.5246 138.242 41.3121C140.458 40.8104 142.758 40.8104 144.975 41.3121Z",
    fill: "#EEEEE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2279 86.9112C26.1729 86.0203 30.2674 86.0203 34.2124 86.9112C35.105 90.8466 35.105 94.9315 34.2124 98.8669C30.2686 99.7678 26.1718 99.7678 22.2279 98.8669C21.3354 94.9315 21.3354 90.8466 22.2279 86.9112Z",
    fill: "#550065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67521 91.1245C11.3019 90.5276 14.0294 90.5276 16.6561 91.1245C17.254 93.7468 17.254 96.4697 16.6561 99.092C14.0294 99.6889 11.3019 99.6889 8.67521 99.092C8.07736 96.4697 8.07736 93.7468 8.67521 91.1245Z",
    fill: "url(#paint3_linear_872_132239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.176 104.845C23.7536 104.49 25.3904 104.49 26.968 104.845C27.3232 106.42 27.3232 108.054 26.968 109.629C25.3914 109.992 23.7526 109.992 22.176 109.629C21.8208 108.054 21.8208 106.42 22.176 104.845Z",
    fill: "#EEEEE4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_872_132239",
    x1: 44.022,
    y1: 17.7902,
    x2: 13.8906,
    y2: 47.9721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFCE6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#967832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_872_132239",
    x1: -287920,
    y1: -4519.09,
    x2: -289904,
    y2: 712.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFCE6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#967832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_872_132239",
    x1: 164.715,
    y1: 40.8104,
    x2: 151.28,
    y2: 54.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_872_132239",
    x1: -13940.1,
    y1: -12055.6,
    x2: -13940.1,
    y2: -12146.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_872_132239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 128,
    fill: "white",
    transform: "translate(190.001 128.004) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatesIcon);
export default __webpack_public_path__ + "static/media/gatesIcon.db07d34b4e614716a1448edf8a34b028.svg";
export { ForwardRef as ReactComponent };